/** Decode JWT payload (client-side only; no signature verification). */
export function parseJwtPayload(token) {
  if (!token || typeof token !== "string") return null;
  try {
    const base64Url = token.split(".")[1];
    if (!base64Url) return null;
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const json = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );
    return JSON.parse(json);
  } catch {
    return null;
  }
}

export function getUserIdFromToken(token) {
  const p = parseJwtPayload(token);
  if (!p) return null;
  return (
    p.sub ||
    p.nameid ||
    p["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"] ||
    null
  );
}

/** JWT role claim(s); ASP.NET uses ClaimTypes.Role URI or short `role`. */
export function getRolesFromToken(token) {
  const p = parseJwtPayload(token);
  if (!p) return [];
  const uri = "http://schemas.microsoft.com/ws/2008/06/identity/claims/role";
  const raw = p[uri] ?? p.role ?? p.roles;
  if (Array.isArray(raw)) return raw.map(String);
  if (raw != null && raw !== "") return [String(raw)];
  return [];
}

export function isAdminToken(token) {
  return getRolesFromToken(token).includes("Admin");
}
